import { LARGE_DOWNLOAD_MESSAGES_COUNT } from "../../../../packages/constants";

export const isAllowedDownload = (messagesLength: number) =>
  messagesLength >= LARGE_DOWNLOAD_MESSAGES_COUNT;
